module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby@5.9.0_2e45v5snrxhxxj6zpu56o774dy/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
